import { autoBindBrandHome } from './bindings/brandHome' 
import { autoBindBindMainApp } from './bindings/bindMainApp'
import mixpanel from 'mixpanel-browser';

import { getFeatureFlag } from './hooks/useFeatureFlag'
import { attachDebugMode } from './legayHelpers/attachDebugMode'

import './index.css'

declare global {
  interface Window { viteBindings: any; jroDebug: Record<string, any> }
}

window.jroDebug = {}

// init mixpanel in prod
try {
  if (window.location.hostname === 'justreachout.io') {
    mixpanel.init("01d15b612162ae641702e3b5efb96538", {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });
  }
} catch (e) {
  console.error('mixpanel init error', e)
}

setTimeout(() => {
  if (!getFeatureFlag('v2')) {
    document.getElementById('new-styles-css')?.remove()
  }
}, 0)

const autoBinders: (() => void)[] = [
  autoBindBrandHome,
  autoBindBindMainApp
];

for (const autoBinder of autoBinders) {
  autoBinder()
  autoBindBindMainApp()
}

try {
  attachDebugMode()
} catch (e) {
  console.error('attachDebugMode error', e)
}

console.log('⚡ JustReachOut loaded! ⚡')
